export default __webpack_public_path__ + "static/media/pots_desktop.db9e23a1.jpg";